"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminGiftCardIntegrationContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const utils_1 = require("../utils");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.adminGiftCardIntegrationContract = c.router({
    getAvailableCampaigns: {
        method: 'GET',
        path: '/:provider/campaigns',
        pathParams: zod_1.z.object({
            provider: models_1.ZSupportedGiftCardProviders,
        }),
        responses: {
            200: zod_1.z.string().array(),
        },
    },
    getGiftCards: {
        method: 'GET',
        path: '/gift-cards',
        query: zod_1.z.object({
            playerId: zod_1.z.string().optional(),
            expired: utils_1.booleanParamSchema.optional(),
            limit: zod_1.z.coerce.number().optional(),
            page: zod_1.z.coerce.number().optional(),
        }),
        responses: {
            200: zod_1.z.object({
                data: models_1.ZGiftCardSelect.array(),
                totalPages: zod_1.z.number(),
            }),
        },
    },
    awardFreeGiftCard: {
        method: 'POST',
        path: '/gift-card',
        body: zod_1.z.object({
            provider: models_1.ZSupportedGiftCardProviders,
            playerId: zod_1.z.string(),
            code: zod_1.z.string(),
        }),
        responses: {
            200: models_1.ZGiftCardSelect.pick({
                provider: true,
                code: true,
                redeemCode: true,
                redeemUrl: true,
                expiresAt: true,
            }),
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
            502: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
}, {
    pathPrefix: '/admin',
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=giftCardIntegration.admin.contract.js.map